import React from "react";
import { describeDimensions, getSpaceCapabilities, getSpacePresentation } from "../spatialModel";

function displayType(value) {
  return value ? value.replaceAll("_", " ") : "Space";
}

export default function SelectedSpace({ space, capabilityCatalog }) {
  if (!space) {
    return (
      <section className="digital-twin-selected" aria-labelledby="selected-space-title">
        <div className="digital-twin-kicker">Selected space</div>
        <h2 id="selected-space-title">No space selected</h2>
        <p className="digital-twin-empty">Space details will appear when the spatial model is available.</p>
      </section>
    );
  }

  const presentation = getSpacePresentation(space);
  const dimensions = describeDimensions(space.dimensions);
  const capabilities = getSpaceCapabilities(space, capabilityCatalog);

  return (
    <section className="digital-twin-selected" aria-labelledby="selected-space-title" aria-live="polite">
      <div className="digital-twin-kicker">Selected space</div>
      <div className="digital-twin-selected-heading">
        <h2 id="selected-space-title">{presentation.label}</h2>
        <span className="digital-twin-type-chip">{displayType(space.type)}</span>
      </div>
      {space.purpose && <p className="digital-twin-purpose">{space.purpose}</p>}
      {space.description && <p className="digital-twin-description">{space.description}</p>}

      {space.tags.length > 0 && (
        <div className="digital-twin-detail-block">
          <h3>Tags</h3>
          <ul className="digital-twin-tags">
            {space.tags.map((tag) => <li key={tag}>{tag}</li>)}
          </ul>
        </div>
      )}

      {dimensions.length > 0 && (
        <div className="digital-twin-detail-block">
          <h3>Dimensions</h3>
          <ul className="digital-twin-dimensions">
            {dimensions.map((dimension) => <li key={dimension}>{dimension}</li>)}
          </ul>
        </div>
      )}

      <div className="digital-twin-detail-block">
        <h3>Capabilities</h3>
        {capabilities.length > 0 ? (
          <ul className="digital-twin-capabilities">
            {capabilities.map((capability) => (
              <li key={capability.id}>
                <span className="digital-twin-capability-symbol" aria-hidden="true">+</span>
                <span>
                  <strong>{capability.label}</strong>
                  <small>Logical capability</small>
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="digital-twin-empty">No capabilities are declared for this space.</p>
        )}
      </div>
    </section>
  );
}